export const REGISTRATIONS_PERMISSIONS = {
	manageClients: 'registrations.manageClients',
} as const;

export type TRegistrationsPermission =
	typeof REGISTRATIONS_PERMISSIONS[keyof typeof REGISTRATIONS_PERMISSIONS];
